<template>
  <main class="py-10 px-4 max-w-7xl mx-auto">
    <h2 class="text-3xl font-bold text-center mb-10">Our Gallery</h2>

    <!-- Masonry-style staggered grid -->
    <div class="columns-1 sm:columns-2 md:columns-3 gap-4">
      <div
        v-for="(image, index) in images"
        :key="index"
        class="mb-4 break-inside-avoid"
      >
        <img
          :src="image"
          alt="Gallery image"
          class="w-full rounded-xl object-cover shadow-md hover:scale-105 transition-transform duration-300"
        />
      </div>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
        images: [
        require('../assets/images/Prints_29.jpg'),
        require('../assets/images/Prints_30.jpg'),
        require('../assets/images/Prints_31.jpg'),
        require('../assets/images/Prints_32.jpg'),
        require('../assets/images/Prints_33.jpg'),
        require('../assets/images/Prints_34.jpg'),
        require('../assets/images/Prints_35.jpg'),
        require('../assets/images/Prints_40.jpg'),
        require('../assets/images/Prints_41.jpg'),
        require('../assets/images/Prints_36.jpg'),
        require('../assets/images/Prints_37.jpg'),
        // require('../assets/images/Prints_38.jpg'),
      ],
    };
  },
};
</script>

<style scoped>
.break-inside-avoid {
  break-inside: avoid;
}
</style>
